import React, { useEffect, useState } from "react";
import { PhoneIcon } from "lucide-react";
export function MobileActionBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById("top");
    const enquire = document.getElementById("enquire");
    let heroVisible = true;
    let enquireVisible = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === enquire) enquireVisible = entry.isIntersecting;
      });
      setVisible(!heroVisible && !enquireVisible);
    }, {
      threshold: 0.05
    });
    if (hero) observer.observe(hero);
    if (enquire) observer.observe(enquire);
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 grid grid-cols-[1fr_auto] gap-3 border-t border-black/15 bg-white px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] md:hidden ${visible ? "translate-y-0" : "translate-y-full"}`} data-id="element-83" data-mp="2zkab05zp7eff">
      <a href="https://bigyellow.au/careers/" tabIndex={visible ? 0 : -1} className="btn btn-primary btn-sm" data-id="element-84" data-mp="15r0skyw3hjoj">View opportunities</a>
      <a href="tel:+61862634753" tabIndex={visible ? 0 : -1} aria-label="Call the Big Yellow office" className="inline-flex h-12 w-12 items-center justify-center border-[1.5px] border-black text-black transition-[background-color,color,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-black hover:text-white active:scale-95" data-id="element-85" data-mp="10ro64f94yemh">
        <PhoneIcon aria-hidden="true" size={20} data-id="element-86" data-mp="htlfxx4uqbn3" />
      </a>
    </div>;
}